"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generate = void 0;
const metaTags_1 = require("./bbb/metaTags");
const metaTags_2 = require("./cbt/metaTags");
/**
 * Generates a key value lookup table with URL paths as keys and video metadata as values. Used for populating
 * meta tags in the <head> of the HTML document for SEO purposes.
 *
 * @param translations An array of translation objects of either BBB or CBT type from the DBS API. See types.ts for more info
 * @returns A lookup table of meta tags
 */
const generate = (translations) => {
    const metaTags = {};
    translations.forEach((translation) => {
        switch (translation.translation_type) {
            case "BBB":
                (0, metaTags_1.populate)(metaTags, translation);
                break;
            case "CBT":
                (0, metaTags_2.populate)(metaTags, translation);
        }
    });
    return metaTags;
};
exports.generate = generate;
